import { Injectable } from '@angular/core';
import { MenuNestedActions, StrapiMenuNestedApiService } from '@core/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';

@Injectable()
export class MenuNestedEffects {
  loadMenuNested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MenuNestedActions.LOAD_MENU_NESTED),
      mergeMap(({ slug, baseStoreCode }: MenuNestedActions.MenuNestedLoad) => {
        return this.menuNestedApiService.getBySlug(slug, baseStoreCode).pipe(
          map((menuNested) => new MenuNestedActions.MenuNestedLoadSuccess(slug, menuNested)),
          catchError((error: unknown) => of(new MenuNestedActions.MenuNestedLoadFail(slug, error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private menuNestedApiService: StrapiMenuNestedApiService,
  ) {}
}
